$(document).ready(function () {
    let breadcrumbObjects, clientName;

    if (compareQueryParams(urlParams, UrlParams.ACTION, Actions.ORDER_EDIT, true)){
        if (!isUndefinedOrNull(urlParams.get(UrlParams.CLIENT_NAME))) {
            ontech.state.do(State.Actions.ORDER_EDIT_CLIENT_NAME_CHANGED, urlParams.get(UrlParams.CLIENT_NAME));
        }
    }

    breadcrumbObjects = $(".breadcrumb__link").map(function () {
        return $(this);
    }).get();
    clientName = ontech.state.get(State.CLIENT_NAME);

    // Google Nest Breadcrumbs
    if (checkClientName(clientName, ClientNames.D2C_GOOGLE_NEST)) {
        $(".step__footer__previous-link").attr("href", "/pages/nest");
        for (const breadcrumb of breadcrumbObjects) {
            if (breadcrumb.attr("href").includes("/cart")) {
                breadcrumb.attr("href", "/cart");
                break;
            }
        }
    }

    // Rocket Mortgage Breadcrumbs
    if (checkClientName(clientName, ClientNames.D2C_ROCKET_MORTGAGE)) {
        $(".step__footer__previous-link").attr("href", "/products/rocket-mortgage-helpful-home-package-hdspcl");
        let stepFooter = $(".step__footer__previous-link-content");
        if (stepFooter.text().includes('cart')) {
            stepFooter.replaceWith('Return to Rocket Mortgage Package Detail');
        }
        for (const breadcrumb of breadcrumbObjects) {
            if (breadcrumb.attr("href").includes("/cart")) {
                breadcrumb.attr("href", "/products/rocket-mortgage-helpful-home-package-hdspcl");
                breadcrumb.text('Rocket Mortgage Package Detail');
                break;
            }
        }
    }

    // Realtor.com Breadcrumbs
    if (checkClientName(clientName, ClientNames.D2C_REALTOR_COM)) {
        $(".step__footer__previous-link").attr("href", "/products/rocket-mortgage-helpful-home-package-hdspcl");
        let stepFooter = $(".step__footer__previous-link-content");
        if (stepFooter.text().includes('cart')) {
            stepFooter.replaceWith('Return to Smart Home Rewards Bundle');
        }
        for (const breadcrumb of breadcrumbObjects) {
            if (breadcrumb.attr("href").includes("/cart")) {
                breadcrumb.attr("href", "/products/realtor-bundle-1-hdspcl");
                breadcrumb.text('Smart Home Rewards Bundle');
                break;
            }
        }
    }
});